import { useMutation } from '@apollo/client';
import { ACCOUNT_GET_CONVERSATIONS } from '@application/components/controllers/pages/MtMessagesPageController/api/useGetConversations';
import { ACCOUNT_GET_MESSAGES } from '@application/components/controllers/pages/MtMessagesPageController/api/useGetMessages';
import { graphql } from '@gql/gql';
import type {
  JoinBuyerSendMessageMutation,
  JoinBuyerSendMessageMutationVariables,
} from '@gql/graphql';

export const JOIN_BUYER_SEND_MESSAGE = graphql(`
  mutation JoinBuyerSendMessage($data: SendMessageInput!) {
    sendMessage(data: $data) {
      id
    }
  }
`);

export const useSendMessage = () => {
  const [send, { data, loading, error }] = useMutation<
    JoinBuyerSendMessageMutation,
    JoinBuyerSendMessageMutationVariables
  >(JOIN_BUYER_SEND_MESSAGE, {
    awaitRefetchQueries: true,
    refetchQueries: [ACCOUNT_GET_MESSAGES, ACCOUNT_GET_CONVERSATIONS],
  });

  const sendMessage = (toAccountId: number, content: string) => {
    return send({
      variables: {
        data: {
          toAccountId,
          content,
        },
      },
    });
  };

  return {
    sendMessage,
    sendMessageLoading: loading,
    sendMessageData: data,
    sendMessageError: error,
  };
};
